import { render } from "./GameResults.vue?vue&type=template&id=55df5f44&scoped=true"
import script from "./GameResults.vue?vue&type=script&lang=js"
export * from "./GameResults.vue?vue&type=script&lang=js"

import "./GameResults.vue?vue&type=style&index=0&id=55df5f44&scoped=true&lang=scss"

import exportComponent from "/builds/chatplace/app-gamification/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55df5f44"]])

export default __exports__